<div class="message-box" [ngClass]="{info: alarmAlert?.level === 1,
  warning: alarmAlert?.level === 2,
  danger: alarmAlert?.level === 3,
  critical: alarmAlert?.level === 4}">
    <p *ngIf="showMessage" @insertRemoveTrigger (click)="removeMessage()">{{ message }}</p>
</div>
